import {
  Form,
  Card,
  Divider,
  Input,
  InputNumber,
  Radio,
  Select,
  Switch,
  DatePicker,
  Button,
  Modal,
  notification,
  message,
  Table,
  List,
} from "antd";
import { useState, useEffect } from "react";
import moment from "moment";
import "./sellThirt.css";
import { format } from "../App";
import MenuBar from "./menu/MenuBar";
import { useSelector, useDispatch } from "react-redux";
import { delUser, setUser } from "../app/features/user/userSlice";
import { postData, getOptionDriver, pad } from "../data/allfunction";
import { useHistory } from "react-router-dom";
import MakeDocLong from "./pdf/MakeDocLong";
import { Spinshow } from "./SellPac";
import { changLg, changLgValue, getDataPost_2, getPDF_2, getTextDate, processClaims, showPolicyEnd } from "../data/allfunction_2";
import text from '../text.json';
const dateFormat2 = "DD-MM-YYYY HH:mm:ss";
const dateFormat = "DD-MM-YYYY";
const ip = process.env.REACT_APP_IP;
const { Option } = Select;
let listUserOverDistcount = ["ZAV2403", "vt002"];
function SellThirt_2() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const userData = useSelector((state) => {
    return state.user;
  });
  const { value } = useSelector((state) => state.lg);
  const { token, retoken, user, user_id, agent_Code, agent_id, agent_c } =
    userData;
  const [listData, setlistData] = useState([]);

  const [modalsave, setmodalsave] = useState(false);
  const [stateButtonSave, setstateButtonSave] = useState(true);
  // --------------------
  const [o_name, seto_name] = useState("");
  const [o_tel, seto_tel] = useState("");
  const [o_type, seto_type] = useState("");
  const [o_make, seto_make] = useState("");
  const [o_plate, seto_plate] = useState("");
  const [o_color, seto_color] = useState("");
  const [o_power, seto_power] = useState("");
  const [o_engine, seto_engine] = useState("");
  const [o_chassis, seto_chassis] = useState("");
  const [o_address, seto_address] = useState("");

  const [o_weight, seto_weight] = useState(0);
  const [o_seats, seto_seats] = useState(0);
  const [a_type_power, set_a_type_power] = useState(0);
  const [oldPolicyNo, set_oldPolicyNo] = useState(null);



  const [a_used, seta_used] = useState("private");
  const [a_type, seta_type] = useState("new");
  const [c_insured, setc_insured] = useState(0);
  const [c_rate, setc_rate] = useState(1);
  const [c_curren, setc_curren] = useState("LAK");
  const [c_tex, setc_tex] = useState(true);

  const [a_premuim, seta_premuim] = useState(0);
  // const [a_premuim_myself, seta_premuim_myself] = useState(0);
  const [a_discount, seta_discount] = useState(0);
  const [a_net_premuim, seta_net_premuim] = useState(0);

  const [h, seth] = useState(0);
  const [i, seti] = useState(0);

  const [c_premuim, setc_premuim] = useState(0);
  const [c_discount, setc_discount] = useState(0);
  const [c_net_premuim, setc_net_premuim] = useState(0);

  const [premuim, setpremuim] = useState(0);
  const [vat, setvat] = useState(10);
  const [register, setregister] = useState(0);
  const [total_premuim, settotal_premuim] = useState(0);

  const [startCover, setstartCover] = useState();
  const [endCover, setendCover] = useState();
  const [sent_startCover, setsent_startCover] = useState();
  const [sent_endCover, setsent_endCover] = useState();

  const [cover, setcover] = useState("");

  const [emp_paid, setemp_paid] = useState(0);
  const [selectedValue_driver_op, setSelectedValue_driver_op] = useState(null);
  // const [modalShowPolicy, setmodalShowPolicy] = useState(false);
  // const [thirdcover_option, setthirdcover_option] = useState([]);
  // const [drivercover_option, setdrivercover_option] = useState([]);
  // const [no, setno] = useState(0);
  // const [datasentPDF, setdatasentPDF] = useState(0);

  const [provice, setprovice] = useState([]);
  const [dist, setdist] = useState([]);
  const [proviceSelect, setproviceSelect] = useState("");
  const [proviceid, setproviceid] = useState(null);
  const [distSelect, setdistSelect] = useState("");
  const [villageSelect, setvillageSelect] = useState("");

  const [loadingPDF, setloadingPDF] = useState(false);

  const [addEnd, setAddEnd] = useState(false);

  const [maxdis, set_maxdis] = useState(0);

  const [car_options, setcar_options] = useState([]);
  const [car_options_show, setcar_options_show] = useState([]);

  const [typedriver, set_typedriver] = useState(null);

  const [carType, setCarType] = useState({});
  const [opCarType, setOpCarType] = useState({});
  const [thirdPatryPremuim, setThirdPatryPremuim] = useState([]);
  const [driveType, setdriveType] = useState([]);
  const [driveAmount, setdriveAmount] = useState(0);
  const [opDriveType, setOpDriveType] = useState([]);

  const [driveTypeOne, setdriveTypeOne] = useState({});
  const [opDriveTypeOne, setOpDriveTypeOne] = useState({});
  const [driverPremuim, setDriverPremuim] = useState([]);

  const [driver_op_code, set_driver_op_code] = useState("");

  const [registerRate, set_registerRate] = useState([]);
  const [getTax, set_getTax] = useState([]);
  const [chekOverdisCount, set_chekOverdisCount] = useState(false);

  const [oldPolicy, set_oldPolicy] = useState([]);

  const thirtClick = (e) => {
    seta_used(e.target.value);
  };

  const motorClick = (e) => {
    seta_type(e.target.value);
  };

  const currencyClick = (e) => {
    setc_curren(e.target.value);
  };
  const taxClick = (e) => {
    setc_tex(e.target.value);
  };

  const optionClick = (e) => {
    try {
      //console.log(e.target.value);
      let data = e.target.value;
      setOpCarType(data);

      console.log("ເມື່ອມີການປ່ຽນແປງທາງເລືອກບຸກຄົນທີສາມ");
      //ລີເຊັດຄ່າທຳນຽມຜູ້ຂັບຂີ່
      setDriverPremuim([]);
      //ລີເຊັດຄ່າທີ່ຈະສົ່ງໄປຖານຂໍ້ມູນ
      set_driver_op_code("");
      //ລີເຊັດຟອມບໍ່ໃຫ້ໂຊ
      setSelectedValue_driver_op(null);
    } catch (error) { }
  };

  useEffect(() => {
    console.log(oldPolicy)
    if (oldPolicy.length > 0) {
      // form.setFieldsValue({ o_name: oldPolicy[0]?.o_name || "" });
      // form.setFieldsValue({ o_name: oldPolicy[0]?.o_name || "" });
      seto_name(oldPolicy[0]?.o_name || "")
      seto_address(oldPolicy[0]?.o_address || "")
      seto_tel(oldPolicy[0]?.o_tel || "")
      seto_type(oldPolicy[0]?.o_type || "")
      seto_make(oldPolicy[0]?.o_make || "")
      seto_plate(oldPolicy[0]?.o_plate || "")
      seto_color(oldPolicy[0]?.o_color || "")
      seto_power(oldPolicy[0]?.o_power || "")
      seto_engine(oldPolicy[0]?.o_engine || "")
      seto_chassis(oldPolicy[0]?.o_chassis || "")
      seto_weight(oldPolicy[0]?.o_weight || 0)
      seto_seats(oldPolicy[0]?.o_seats || 0)
      set_oldPolicyNo(`${oldPolicy[0]?.type == "ONLINE" ? "E-":" "} ${oldPolicy[0]?.policy_concat_no}` || null)
    }

  }, [oldPolicy])

  useEffect(() => {

    if (proviceSelect === '') {
      seto_address(``)
    } else {
      seto_address(`${villageSelect} ເມືອງ ${distSelect} ແຂວງ ${proviceSelect}`)
    }
  }, [villageSelect, distSelect, proviceSelect])


  useEffect(() => {
    if (a_type == "renew") {
      Modal.info({
        title: ` ${changLgValue(value, 94)}`,
        content: (
          <FromFineOldPolicy
            agent_Code={agent_Code}
            token={token}
            retoken={retoken}
            set_oldPolicy={set_oldPolicy}
            value={value}
          />
        ),
        okText: ` ${changLgValue(value, 106)}`, // ປິດໜ້າຕ່າງ
        onOk() {
          console.log('OK clicked');
        },    
        width: 700
      });
    } else {
      set_oldPolicyNo(null)
    }
    console.log(a_type)
    set_oldPolicy([])
  }, [a_type])

  useEffect(() => {
    //ອະນຸຍາດໃຫ້ມີການຂາຍອອນໄລໂຕລົດ
    if (agent_c === 1) {
      set_chekOverdisCount(true);
    } else {
      set_chekOverdisCount(false);
    }
  }, [agent_c]);

  //ເລືອກປະເພດລົດ
  function onChange_Car(value) {
    console.log("onChange_Car");
    try {
      let data = JSON.parse(value);
      setCarType(data);
      console.log(data);
      console.log(data.car_type_name_la);
      seto_type(data.car_type_name_la);
    } catch (error) {
      console.log(error);
    }
  }

  //ເມື່ອປະເພດລົດ ແລະ ປະເພດອອບຊັ່ນມີການປ່ຽນແປງ ແລ້ວດຶງເອົາຄ່າທຳນຽມບຸກຄົນທີສາມ
  useEffect(async () => {
    try {
      if (
        carType?.car_type_id != undefined &&
        opCarType?.car_op_id != undefined
      ) {
        let l = ip + "sell_2_online/car_option_detail";
        let dataSetForGet = {
          car_type_id: carType?.car_type_id,
          car_op_id: opCarType?.car_op_id,
        };
        let third = await getDataPost_2(l, dataSetForGet, token, retoken);
        //console.log(third);
        if (third?.length > 0) {
          if (third[0].car_option_detial_status === 1) {
            setThirdPatryPremuim(third);
          } else {
            throw new Error("ແພັກແກັດນີ້ຖືກປິດການຂາຍ");
          }
        } else {
          throw new Error("ແພັກແກັດນີ້ຍັງບໍ່ມີ");
        }
      }
    } catch (error) {
      console.log(error);
      alert(
        // "ປະເພດລົດດັ່ງກ່າວ ບໍ່ສາມາດຂາຍທາງເລືອກນີ້ໃດ້ ກະລຸນາກວດສອບຄືນໃໝ່"
        changLgValue(value, 84)
      );
      setThirdPatryPremuim([]);
      setOpCarType({});
    }
  }, [carType, opCarType]);

  //ເມື່ອປະເພດຜູ້ຂັບຂີ່ ແລະ ປະເພດອອບຊັ່ນມີການປ່ຽນແປງ ແລ້ວດຶງເອົາຄ່າທຳນຽມຜູ້ຂັບຂີ່
  useEffect(async () => {
    try {
      if (
        opDriveTypeOne?.driver_op_id != undefined &&
        driveTypeOne?.driver_id != undefined
      ) {
        // console.log("opDriveTypeOne", opDriveTypeOne);
        // console.log("driveTypeOne", driveTypeOne);

        let l = ip + "sell_2_online/driver_options_detail";
        let dataSetForGet = {
          driver_id: driveTypeOne?.driver_id,
          driver_op_id: opDriveTypeOne?.driver_op_id,
        };
        let driver = await getDataPost_2(l, dataSetForGet, token, retoken);
        //  console.log(driver);
        if (driver?.length > 0) {
          // console.log(driver[0].driver_option_detail_id);
          setDriverPremuim(driver);
        } else {
          throw new Error("ບໍ່ພົບແພັກແກັດຜູ້ຂັບຂີ່ນີ້");
        }
      }
    } catch (error) {
      console.log(error);
      alert(
        // "ປະເພດຜູ້ຂັບຂີ່ດັ່ງກ່າວ ບໍ່ສາມາດຂາຍທາງເລືອກນີ້ໃດ້ ກະລຸນາກວດສອບຄືນໃໝ່"
        changLgValue(value, 83)
      );
      //ລີເຊັດຄ່າທຳນຽມຜູ້ຂັບຂີ່
      setDriverPremuim([]);
      //ລີເຊັດຄ່າທີ່ຈະສົ່ງໄປຖານຂໍ້ມູນ
      set_driver_op_code("");
      //ລີເຊັດຟອມບໍ່ໃຫ້ໂຊ
      setSelectedValue_driver_op(null);


      // ຄ່າທຳນຽມຜູ້ຂັບຂີ່
      seti(0)
      // ຈຳນວນຜູ້ຂັບຂີ່
      setdriveAmount(0)
      // ປະເພດຜູ້ຂັບຊີ່
      form.resetFields(["driveType"]);
      // ທາງເລືອກຜູ້ຂັບຂີ່
      form.resetFields(["optionType"]);
    }
  }, [driveTypeOne, opDriveTypeOne]);

  //ເມື່ອເງິນບຸກຄົນທີສາມ ແລະ ຜູ້ຂັບຂີ່ມີການປ່ຽນແປງ
  useEffect(() => {
    //ຄ່າທຳນຽມບຸກຄົນທີສາມ
    if (thirdPatryPremuim.length > 0) {
      //  console.log("thirdPatryPremuim", thirdPatryPremuim);
      seta_premuim(thirdPatryPremuim[0].car_option_detial_premuim);
      //ສ່ວນຫຼຸດສູງສຸດທີ່ໄດ້

      if (chekOverdisCount) {
        //ຖ້າຕົວແທນຍູ່ໃນລິດສາມາດລຸດໃດ້ເຖິງ 70 ເປີເຊັນ
        set_maxdis(70);
      } else {
        set_maxdis(thirdPatryPremuim[0].car_option_detial_max_dis_online);
      }
    } else {
      set_maxdis(0);
      seta_premuim(0);
    }

    //ຄ່າທຳນຽມຜູ້ຂັບຂີ່

    if (driverPremuim.length > 0) {
      if (driverPremuim[0]?.driver_id == 2) {
        //ຖ້າຫາກວ່າປະເພດລົດແມ່ນ ລົດສອງລໍ້ ສາມລໍ້
        if (driveAmount == 1) {
          //ຖ້າວ່າຜູ້ຂັບຂີ່ເທົ່າ1ຄົນ
          seti(driverPremuim[0]?.driver_option_detail_premium * driveAmount);
        } else {
          if (driverPremuim[0]?.driver_op_id == 1) {
            seti(10500);
          } else if (driverPremuim[0]?.driver_op_id == 2) {
            seti(18500);
          } else if (driverPremuim[0]?.driver_op_id == 3) {
            seti(34500);
          } else if (driverPremuim[0]?.driver_op_id == 4) {
            seti(45000);
          } else if (driverPremuim[0]?.driver_op_id == 5) {
            seti(74000);
          }
        }
      } else {
        seti(driverPremuim[0]?.driver_option_detail_premium * driveAmount);
      }
    } else {
      seti(0);
    }
  }, [thirdPatryPremuim, driverPremuim, driveAmount]);

  function onChange_timestart(value, dateString) {
    setstartCover(moment(value).format(dateFormat));
    setsent_startCover(value);

    // console.log('next 1 year: ',moment(value).add(1, 'Y').subtract(1, 'd').format(dateFormat))
    // console.log('now: ',moment(value).format(dateFormat))

    setendCover(moment(value).add(1, "Y").subtract(1, "d").format(dateFormat));
    setsent_endCover(moment(value).add(1, "Y").subtract(1, "d"));
  }

  function onChange_timeend(value, dateString) {
    setendCover(moment(value).format(dateFormat));
    setsent_endCover(value);
  }

  //ຟັ່ງຊັ່ນດາວໂຫລດ ສັນຍາເປັນພີດີເອຟ
  async function get_pdf_policy(no) {
    let l = ip + "sell_2_online/pdf_log";
    let dataSetForGet = { no };
    let pro = await getPDF_2(l, dataSetForGet, token, retoken);

    // Create a temporary URL representing the Blob
    const url = window.URL.createObjectURL(pro);

    // Create a link element
    const a = document.createElement("a");
    a.href = url;
    a.download = pad(no);

    // Append the link to the body
    document.body.appendChild(a);

    // Trigger a click event on the link to initiate download
    a.click();

    // Cleanup
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }

  //ສ້າງສັນຍາ ແລະ ດາວໂຫລດ
  async function createPolicy() {
    //setmodalsave(false);
    setstateButtonSave(false);
    let link = `${ip}sell_online/long`;
    const dataSetForGet = {
      o_name: o_name,
      o_address: o_address,
      // o_address: `${villageSelect} ເມືອງ ${distSelect} ແຂວງ ${proviceSelect}`,
      o_tel: o_tel,
      o_type: o_type,
      o_make: o_make,
      o_plate: o_plate,
      o_color: o_color,
      o_power: o_power,
      o_engine: o_engine,
      o_chassis: o_chassis,
      o_weight: o_weight,
      o_seats: o_seats,
      a_used: a_used,
      a_type: a_type,
      c_insured: c_insured,
      c_curren: c_curren,
      c_tex: c_tex,
      a_premuim: a_premuim,
      a_discount: a_discount,
      a_net_premuim: a_net_premuim,
      h: h,
      i: i,
      c_premuim: c_premuim,
      c_discount: c_discount,
      c_net_premuim: c_net_premuim,
      premuim: premuim,
      vat: vat,
      register: register,
      total_premuim: total_premuim,
      start: moment(sent_startCover).format("YYYY-MM-DD"),
      end: moment(sent_endCover).format("YYYY-MM-DD"),
      cover: cover,
      user_add: user_id,
      dateadd: Date.now(),
      emp_paid: emp_paid,
      driver_id: typedriver,
      a_type_power
      
    };

    if (!thirdPatryPremuim[0].car_option_detial_id) {
      alert("ກະລຸນາກວດສອບປະເພດລົດ ຫຼື ທາງເລືອກການຄຸ້ມກັນຄືນໃໝ່");
      return;
    }
    if (!driverPremuim[0].driver_option_detail_id) {
      alert("ກະລຸນາກວດສອບປະເພດຜູ້ຂັບຂີ່ ແລະ ເລືອກເລືອກການຄຸ້ມກັນຄືນໃໝ່");
      return;
    }

    let new_dataSetForGet = {
      // agent_id: agent_id,

      thirdData: {
        car_option_detial_id:
          thirdPatryPremuim.length > 0
            ? thirdPatryPremuim[0].car_option_detial_id
            : null,
      },
      typedriverdata: {
        driver_option_detail_id:
          driverPremuim.length > 0
            ? driverPremuim[0].driver_option_detail_id
            : null,
      },
      emp_add: null,
      thediductible: "ສ້າງຈາກຍູເຊີ້ຕົວແທນ",
      oldPolicyNo
      //  agent_code: agent_Code,
    };

    let rows = { ...dataSetForGet, ...new_dataSetForGet };
    //  console.log({ ...dataSetForGet, ...new_dataSetForGet });
    setloadingPDF(true);
    let l = ip + "sell_2_online/insert_long";

    let addpolicy = await getDataPost_2(l, rows, token, retoken);

    // console.log(addpolicy);

    //   {
    //     "fieldCount": 0,
    //     "affectedRows": 1,
    //     "insertId": 1007,
    //     "info": "",
    //     "serverStatus": 2,
    //     "warningStatus": 0
    // }

    if (addpolicy.affectedRows === 1) {
      notification["success"]({
        message: "ແຈ້ງເຕືອນ",
        description:
          "ສ້າງສັນຍາປະກັນໄພອອນລາຍ ເລກທີ: " +
          pad(addpolicy.insertId) +
          " ສຳເຫຼັ້ດ ກະລຸນາກວດສອບໂຟເດີ້ ດາວໂລດ",
      });
      setmodalsave(false);
      get_pdf_policy(addpolicy.insertId);
      setTimeout(() => {
        setloadingPDF(false);
        window.location.reload();
        notification.destroy();
      }, 6000);
    } else {
      setloadingPDF(false);
      setmodalsave(false);
    }
    setTimeout(() => {
      setstateButtonSave(true);
    }, 3000);
  }

  //ດຶງປະເພດລົດທັງໝົ້ດ
  useEffect(async () => {
    let l = ip + "sell_2_online/car_type";
    let dataSetForGet = {};
    let pro = await getDataPost_2(l, dataSetForGet, token, retoken);
    //console.log(pro);
    if (pro?.length > 0) {
      setlistData(pro);
    } else {
      setlistData([]);
    }

    let lcar_options = ip + "sell_2_online/car_options";
    let dataSetForGetcar_options = {};
    let procar_options = await getDataPost_2(
      lcar_options,
      dataSetForGetcar_options,
      token,
      retoken
    );
    //console.log(procar_options);
    if (procar_options?.length > 0) {
      setcar_options(procar_options);
      setcar_options_show(procar_options);
    } else {
      setcar_options([]);
      setcar_options_show([]);
    }
  }, []);

  //ດຶງແຂວງທັງໝົ້ດ
  useEffect(async () => {
    let l = ip + "sell_2_online/provice";
    let dataSetForGet = {};
    let pro = await getDataPost_2(l, dataSetForGet, token, retoken);
    // console.log(pro);
    if (pro?.length > 0) {
      setprovice(pro);
    } else {
      setprovice([]);
    }

    //
  }, []);
  //ລາຍຊື່ເມືອງຕາມແຂວງ
  useEffect(async () => {
    setdist([]);
    if (proviceid != null) {
      let l = ip + "sell_2_online/distic";
      let dataSetForGet = { dist_provice: proviceid };
      let dis = await getDataPost_2(l, dataSetForGet, token, retoken);
      //   console.log(dis);
      if (dis?.length > 0) {
        setdist(dis);
      } else {
        setdist([]);
      }
    }
  }, [proviceid]);

  //ດຶງຂໍ້ມູຄ່າລົງທະບຽນ
  useEffect(async () => {
    let l = ip + "sell_2_online/registerRate";
    let dataSetForGet = {};
    let _registerRate = await getDataPost_2(l, dataSetForGet, token, retoken);
    //  console.log(_registerRate);
    if (_registerRate?.length > 0) {
      set_registerRate(_registerRate);
    } else {
      set_registerRate([]);
    }

    //
  }, []);

  //ດຶງຂໍ້ມູນອາກອນມູນຄ່າເພີ່ມ
  useEffect(async () => {
    let l = ip + "sell_2_online/tax";
    let dataSetForGet = {};
    let _tax = await getDataPost_2(l, dataSetForGet, token, retoken);
    //  console.log(_tax);
    if (_tax?.length > 0) {
      const vat = getTextDate(_tax[0].tax_value);
      // set_getTax(_tax[0].tax_value);
      set_getTax(vat);
    } else {
      set_getTax(0);
    }

    //
  }, []);

  //ດຶງປະເພດຜູ້ຂັບຂີ່ ແລະ ທາງເລືອກຜູ້ຂັບຂີ່ ທັງໝົດ
  useEffect(async () => {
    let l = ip + "sell_2_online/drivers";
    let dataSetForGet = {};
    let driver = await getDataPost_2(l, dataSetForGet, token, retoken);
    //console.log(driver);
    if (driver?.length > 0) {
      setdriveType(driver);
    } else {
      setdriveType([]);
    }

    let l2 = ip + "sell_2_online/driver_options";
    let dataSetForGet2 = {};
    let op_driver = await getDataPost_2(l2, dataSetForGet2, token, retoken);
    //  console.log(op_driver);
    if (op_driver?.length > 0) {
      setOpDriveType(op_driver);
    } else {
      setOpDriveType([]);
    }
  }, []);

  useEffect(() => {
    // --------
    if (c_curren === "LAK") {
      setc_rate(1);
    }

    // ---------------ຄິດໄລ່ຄ່າທຳນຽມຕົ້ນໂຕລົດ
    let c;
    if (c_tex) {
      c = 3.5 / 100;
    } else {
      c = 4.2 / 100;
    }
    let c_p = c_insured * c_rate * c;
    setc_premuim(c_p);

    // ------------------ ຄິດໄລ່ຄ່າທຳນຽມໂຕລົດ
    let c_n;
    if (c_discount > 0) {
      c_n = c_p * (c_discount / 100);
    } else {
      c_n = 0;
    }
    setc_net_premuim(c_p - c_n);

    // ----------------------ຄິດໄລ່ຄ່າທຳນຽມບຸກຄົນທີສາມ
    let a_n;
    if (a_discount > 0) {
      a_n = a_premuim * (a_discount / 100);
    } else {
      a_n = 0;
    }
    seta_net_premuim(a_premuim - a_n);

    // ---------------------ຄິດໄລ່ປົກປ້ອງສິດ
    seth(a_net_premuim * 0.05);

    // ຄິດໄລ່ຄ່າທຳນຽມບໍ່ລວມອາກອນ----------
    let pr = a_net_premuim + h + i + c_net_premuim;
    setpremuim(pr);

    // ຄິດໄລອາກອນມູູນຄ່າເພີ່ມ------------
    let v = pr * getTax;
    setvat(v);

    // ຄິດໄລ່ຄ່າຂື້ນທະບຽນ-----------

    let r;
    // if (pr <= 10000000) {
    //   r = 20000;
    // } else if (pr <= 50000000) {
    //   r = 30000;
    // } else if (pr <= 100000000) {
    //   r = 40000;
    // } else {
    //   r = 100000;
    // }
    r = caculate_regiter(pr);

    setregister(r);

    // ຄິດໄລ່ລວມມູນຄ່າຕ້ອງຈ່າຍ----------
    settotal_premuim(pr + v + r);

    //---------------------
    let cc;
    if (c_insured > 0) {
      cc = "-C";
    } else {
      cc = "";
    }
    // let cv = opCarType?.car_op_name + "-H-I5" + cc;
    let carOp =
      opCarType?.car_op_name == undefined ? "" : opCarType.car_op_name;
    let cv = carOp + "-H-" + driver_op_code + cc;

    setcover(cv);
    // console.log(cv);
  }, [
    c_curren,
    c_tex,
    c_insured,
    c_rate,
    c_discount,
    a_discount,
    a_premuim,
    a_net_premuim,
    h,
    i,
    c_net_premuim,

  ]);

  useEffect(() => {

    // console.log("driveTypeOne", driveTypeOne);
    // console.log("selectedValue_driver_op", selectedValue_driver_op);
    // console.log("driveAmount", driveAmount);

    console.log("driverPremuim", driverPremuim);

  }, [driveTypeOne, selectedValue_driver_op, driveAmount]);


  function onChange_pro(p) {
    // console.log(p)
    let pro = JSON.parse(p);
    setproviceid(pro.provice_id);
    setproviceSelect(pro.provice_name);
    setdist([]);
  }
  function onChange_dist(d) {
    let dis = JSON.parse(d);
    setdistSelect(dis.dist_name);
  }
  function onChange_v(v) {
    setvillageSelect(v.target.value);
  }
  const submitForm = (e) => {
    function add() {
      if (opCarType?.car_op_name === "" || opCarType?.car_op_name === null) {
        alert("ກະລຸນາເລືອກ  Option ໃຫ້ຖືກຕ້ອງ");
      } else {
        setmodalsave(true);
      }
    }

    if (c_premuim > 0) {
      alert("ທ່ານກຳລັງຈະອອກສັນຍາປະກັນໄພໂຕລົດ");
      if (opCarType?.car_op_name == "A3") {
        add();
      } else {
        if (userData.agent_c == 1) {
          // if (user_id == 6 || user_id == 103) {

          //userData.agent_c == 1 ແມ່ນຜູ້ໄດ້ຮັບອະນຸຍາດ ຂາຍອອນລາຍ
          alert("ທ່ານກຳລັງຂາຍປະກັນໄພລົດແບບຮອບດ້ານໂດຍທີ່ໃຊ້ທາງເລືອກບໍ່ແມ່ນ A3 ");

          add();
        } else {
          alert("ປະກັນໂຕລົດແມ່ນຂາຍສະເພາະ ທາງເລືອກ A3 ເທົ່ານັ້ນ");
        }
      }
    } else {
      add();
    }

    // form.resetFields()
  };

  function caculate_regiter(pr) {
    try {
      let rate = 0;
      for (let i = 0; i < registerRate.length; i++) {
        let entry = registerRate[i];
        if (entry.register_ifstart !== null && entry.register_if !== null) {
          if (pr >= entry.register_ifstart && pr <= entry.register_if) {
            rate = entry.register_rate;
            break;
          }
        }
      }
      return rate;
    } catch (error) {
      return 0;
    }
  }

  function setShowI(v) {
    let showI = JSON.parse(v).driver_op_code;
    if (showI === "null") {
      set_driver_op_code("");
    } else {
      let showI_and_amount;
      if (driveAmount > 0) {
        showI_and_amount = showI + "/" + driveAmount;
      } else {
        showI_and_amount = showI;
      }
      set_driver_op_code(showI_and_amount);
    }
  }

  useEffect(() => {
    try {
      let showI = opDriveTypeOne.driver_op_code;
      if (showI === "null") {
        set_driver_op_code("");
      } else {
        let showI_and_amount;
        if (driveAmount > 0) {
          showI_and_amount = showI + "/" + driveAmount;
        } else {
          showI_and_amount = showI;
        }
        set_driver_op_code(showI_and_amount);
      }
    } catch (error) { }
  }, [opDriveTypeOne, driveAmount]);

  useEffect(() => {
    console.log(c_insured);
    try {
      if (c_insured > 0) {
        // console.log(userData?.agent_unlock_a);
        let aArray = userData?.agent_unlock_a.split(",");
        let filteredArray = car_options.filter((item) =>
          aArray.includes(item.car_op_name)
        );
        //ສ້າງລິດການອະນຸຍາດຂາຍໂຕລົດທີ່ລະບຸໃນຖານຂໍ້ມູນ
        setcar_options_show(filteredArray);
        //ເຊັດຄ່າທຳນຽມຕົ້ນປະກັນໄພບຸກຄົນທີສາມໃຫ້ເປັນ 0
        seta_premuim(0);
      } else {
        throw new Error("");
      }
    } catch (error) {
      setcar_options_show(car_options);
    }
  }, [c_insured]);
  // console.log(userData.agent_conf);
  // console.log(userData);
  return (
    <>
      <MenuBar />
      {/* {JSON.stringify(oldPolicy)} */}
      {loadingPDF ? (
        <Spinshow />
      ) : (
        <Form
          form={form}
          name="sellpac"
          // labelCol={{ span: 8 }}
          // wrapperCol={{ span: 16 }}
          initialValues={{ remember: true }}
          onFinish={submitForm}
          autoComplete="off"
        >
          <div className="container">
            <Card className="C">
              <Divider orientation="left" plain>
                {/* ຂໍ້ມູນຂອງຜູ້ໄດ້ຮັບການປະກັນໄພ ເວີຊັ່ນ 2 */}
                {/* {text.Sheet1[6-1].ch}  */}

                {changLgValue(value, 6)} v2
              </Divider>
              <div style={{ display: "flex" }}>
                <div style={{ flex: 2, paddingRight: 10 }}>
                  <Input
                    className="TI"
                    placeholder={changLgValue(value, 7)}
                    onChange={(e) => {
                      seto_name(e.target.value);
                    }}
                    value={o_name}
                  />
                  {/* <Input className='TI' placeholder="ທີ່ຢູ່"
                                onChange={(e) => {
                                    seto_address(e.target.value)
                                }}
                            /> */}
                  <div className="row row-cols-1 row-cols-md-3">
                    <div className="col">
                      <Select
                        placeholder={changLgValue(value, 8)}
                        optionFilterProp="children"
                        onChange={onChange_pro}
                        className="TI"
                        style={{ width: "100%" }}
                      >
                        {provice.map((v) => {
                          return (
                            <Option
                              key={v.provice_id}
                              value={JSON.stringify(v)}
                            >
                              {v.provice_name}
                            </Option>
                          );
                        })}
                      </Select>
                    </div>
                    <div className="col">
                      <Select
                        placeholder={changLgValue(value, 9)}
                        optionFilterProp="children"
                        onChange={onChange_dist}
                        className="TI"
                        style={{ width: "100%" }}
                      >
                        {dist.map((v) => {
                          return (
                            <Option key={v.dist_id} value={JSON.stringify(v)}>
                              {v.dist_name}
                            </Option>
                          );
                        })}
                      </Select>
                    </div>
                    <div className="col">
                      <Input
                        className="TI"
                        placeholder={changLgValue(value, 10)}
                        onChange={onChange_v}
                      />
                    </div>
                  </div>

                  {o_address === '' ? null : <p style={{ color: 'red' }}> {o_address}</p>}

                  <Input
                    className="TI"
                    placeholder={changLgValue(value, 11)}
                    onChange={(e) => {
                      seto_tel(e.target.value);
                    }}
                    value={o_tel}
                  />

                  <Input
                    className="TI"
                    placeholder={changLgValue(value, 12)}
                    onChange={(e) => {
                      seto_make(e.target.value);
                    }}
                    value={o_make}
                  />
                  <Input
                    className="TI"
                    placeholder={changLgValue(value, 13)}
                    onChange={(e) => {
                      seto_plate(e.target.value);
                    }}
                    value={o_plate}
                  />
                  <Input
                    className="TI"
                    placeholder={changLgValue(value, 14)}
                    onChange={(e) => {
                      seto_color(e.target.value);
                    }}
                    value={o_color}
                  />

                  <Input
                    className="TI"
                    placeholder={changLgValue(value, 15)}
                    onChange={(e) => {
                      seto_power(e.target.value);
                    }}
                    value={o_power}
                  />

                  <Input
                    className="TI"
                    placeholder={changLgValue(value, 16)}
                    onChange={(e) => {
                      seto_engine(e.target.value.toUpperCase());                 
                    }}
                    value={o_engine}
                  />
                  <Input
                    className="TI"
                    placeholder={changLgValue(value, 17)}
                    onChange={(e) => {
                      seto_chassis(e.target.value.toUpperCase());
                    }}
                    value={o_chassis}
                  />
                  <InputNumber
                    className="TIN"
                    max={50}
                    // placeholder="ນ້ຳໜັກຄິດໄລ່ເປັນໂຕນ"
                    placeholder={changLgValue(value, 18)}
                    onChange={(e) => {
                      seto_weight(e);
                    }}
                    value={o_weight > 0 ? o_weight : ""}
                  />
                  <InputNumber
                    className="TIN"
                    min={0}
                    max={50}
                    // placeholder="ຈຳນວນບ່ອນນັ່ງ"
                    placeholder={changLgValue(value, 19)}
                    onChange={(e) => {
                      seto_seats(e);
                    }}
                    value={o_seats > 0 ? o_seats : ""}
                  />
                  {fromTypeCar(a_type_power, set_a_type_power, value)}
                </div>
              </div>
            </Card>
            <Card className="C">
              <Divider orientation="left" plain>
                {/* ປະເພດຂອງສັນຍາປະກັນໄພ */}
                {changLgValue(value, 23)}
              </Divider>
              {/* ພາກທີ 1: ການປະກັນໄພ ທາງແພ່ງຕໍ່ບຸກຄົນທີສາມ */}
              {changLgValue(value, 24)}
              <Radio.Group onChange={thirtClick} value={a_used} className="R">
                <Radio value={"private"}>
                  {/* ລົດສ່ວນຕົວ */}
                  {changLgValue(value, 25)}
                </Radio>
                <Radio value={"business"}>
                  {/* ຮັບຈ້າງ */}
                  {changLgValue(value, 26)}
                </Radio>
              </Radio.Group>
              <Radio.Group onChange={motorClick} value={a_type} className="R">
                <Radio value={"new"}>
                  {/* ສັນຍາໃໝ່ */}
                  {changLgValue(value, 27)}
                </Radio>
                <Radio value={"renew"}>
                  {/* ຕໍ່ສັນຍາ */}
                  {changLgValue(value, 28)}  {oldPolicy.length > 0 && `/ ${changLgValue(value, 95)}: ${oldPolicy[0]?.type} : ${changLgValue(value, 98)} : ${oldPolicy[0]?.policy_concat_no}`}
                </Radio>
              </Radio.Group>
              <br />
              {/* ພາກທີ 2: ການປະກັນໄພ ຕົວລົດ (ມູນຄ່າລົດໃໝ່ສຳຫຼັບຄ້ຳປະກັນຂໍ້ ຄ ຫຼື ງ) */}
              {changLgValue(value, 29)}
              <br />
              <Radio.Group
                onChange={currencyClick}
                value={c_curren}
                className="R"
              >
                <Radio value={"LAK"}>LAK</Radio>

                {/* 
                <Radio value={"USD"}>USD</Radio>
                <Radio value={"THB"}>THB</Radio>
                */}
              </Radio.Group>
              {agent_c === 1 && (
                <div style={{ display: "flex" }}>
                  <div style={{ flex: 2, paddingRight: 5 }}>
                    <InputNumber
                      className="TIN"
                      placeholder={changLgValue(value, 30)}
                      onChange={(e) => setc_insured(e)}
                    />
                  </div>
                  {c_curren !== "LAK" && (
                    <div style={{ flex: 1 }}>
                      <InputNumber
                        min={1}
                        className="TIN"
                        placeholder="ອັດຕາແລກປ່ຽນ"
                        onChange={(e) => setc_rate(e)}
                      />
                    </div>
                  )}
                </div>
              )}
              <Radio.Group onChange={taxClick} value={c_tex} className="R">
                <Radio value={true}>
                  {/* ເສຍພາສີ */}
                  {changLgValue(value, 31)}
                </Radio>
                <Radio value={false}>
                  {/* ບໍ່ເສຍພາສີ */}
                  {changLgValue(value, 32)}
                </Radio>
              </Radio.Group>
            </Card>
            <Card className="C">
              <Divider orientation="left" plain>
                {/* ທາງເລືອກສຳຫຼັບປະກັນໄພລົດ */}
                {changLgValue(value, 33)}
              </Divider>
              {/* <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>ຂອບເຂດການຄຸ້ມກັນ ແລະ ທາງເລືອກ</th>
                    <th>ຄິດໄລຄ່າທຳນຽມເບື້ອງຕົ້ນ</th>
                    <th>ສ່ວນຫຼຸດ</th>
                    <th>ຄ່າທຳນຽມຕົວຈິງ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      ຄວາມຮັບຜິດຊອບທາງແຜ່ງຕໍ່ບຸກຄົນທີສາມ
                      <Select
                        placeholder="ປະເພດລົດ"
                        optionFilterProp="children"
                        onChange={onChange_Car}
                        className="TI"
                        style={{ width: "100%" }}
                      >
                        {listData.map((v, i) => {
                          return v.car_type_ml === 1 ? (
                            <Option key={i} value={JSON.stringify(v)}>
                              {v.car_type_name_la}
                            </Option>
                          ) : null;
                        })}
                      </Select>
                      <hr />
                      <Form.Item
                        // label=" ເລືອກປະເພດລົດ::"
                        name="o_optinname"
                        rules={[
                          {
                            required: true,
                            message: "ກະລຸນາເລືອກ  Option",
                          },
                        ]}
                        className="mb-0"
                      >
                        <Radio.Group
                          onChange={optionClick}
                          // value={a_option}
                          className="R"
                        >
                          {car_options_show.map((e, k) => {
                            return (
                              <Radio key={k} value={e}>
                                {e.car_op_name}
                              </Radio>
                            );
                          })}
                        </Radio.Group>
                      </Form.Item>
                    </td>
                    <td>
                      <Input
                        className="TIN"
                        value={a_premuim}
                        placeholder="ຄ່າທຳນຽມຕົ້ນ"
                      />
                    </td>
                    <td>
                      <InputNumber
                        className="TIN"
                        min={0}
                        //   max={maxdis}
                        max={maxdis}
                        value={a_discount}
                        placeholder="ສ່ວນຫຼຸດ"
                        onChange={(e) => seta_discount(e)}
                      />
                    </td>
                    <td>
                      <Input
                        className="TIN"
                        readOnly
                        value={format(a_net_premuim)}
                        placeholder="ຄ່າທຳນຽມຕົວຈິງ"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={3}>ປົກປ້ອງສິດແລະຮຽກສິນທົດແທນ</td>
                    <td>
                      <InputNumber
                        className="TIN"
                        readOnly
                        min={0}
                        placeholder="ປົກປ້ອງສິດ"
                        value={h}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      ປະເພດຜູ້ຂັບຂີ່
                      <hr />
                      <Radio.Group
                        onChange={(v) => {
                          // console.log("ປະເພດຜູ້ຂັບຂີ່");
                          setdriveTypeOne(v.target.value);
                        }}
                        className="R"
                      >
                        {driveType.map((e, k) => {
                          return (
                            <Radio key={k} value={e}>
                              {e.driver_name}
                            </Radio>
                          );
                        })}
                      </Radio.Group>
                    </td>
                    <td>
                      ທາງເລືອກຜູ້ຂັບຂີ່
                      <hr />
                      <Select
                        placeholder="ທາງເລືອກຜູ້ຂັບຂີ່"
                        value={selectedValue_driver_op}
                        onChange={(v) => {
                          //   console.log(v);
                          setSelectedValue_driver_op(
                            JSON.parse(v).driver_op_code
                          );
                          setOpDriveTypeOne(JSON.parse(v));
                        }}
                        className="TI"
                        style={{ width: "100%" }}
                      >
                        {opDriveType?.map((v) => {
                          // console.log(v.driver_op_id);
                          // console.log(v.driver_op_code);
                          if (
                            v?.driver_op_id == 1 ||
                            v?.driver_op_id == 2 ||
                            v?.driver_op_id == 3 ||
                            v?.driver_op_id == 4
                          ) {
                            return;
                          }

                          if (opCarType.car_op_name == "A4") {
                            //ຖ້າວ່າທາງເລືອກການຂາຍແມ່ນ A4 ໃຫ້ສາມາດເລືອກ I6 ໄດ້
                            return (
                              <Option
                                key={v.driver_op_id}
                                value={JSON.stringify(v)}
                              >
                                {v.driver_op_code}
                              </Option>
                            );
                          } else {
                            if (v.driver_op_id != 8) {
                              return (
                                <Option
                                  key={v.driver_op_id}
                                  value={JSON.stringify(v)}
                                >
                                  {v.driver_op_code}
                                </Option>
                              );
                            }
                          }
                        })}
                      </Select>
                    </td>
                    <td>
                      ຈຳນວນຜູ້ຂັບຂີ່ {driveAmount}
                      <hr />
                      <InputNumber
                        className="TIN"
                        min={0}
                        max={50}
                        value={driveAmount}
                        onChange={(e) => setdriveAmount(e)}
                      />
                    </td>
                    <td>
                      <Input
                        className="TIN"
                        readOnly
                        min={0}
                        placeholder="ຜູ້ຂັບຂີ່"
                        value={format(i)}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>ຄວາມເສຍຫາຍຕໍ່ກັບໂຕລົດ</td>
                    <td>
                      <Input
                        className="TIN"
                        readOnly
                        min={0}
                        placeholder="ຄ່າທຳນຽມຕົ້ນ"
                        value={format(c_premuim)}
                      />
                    </td>
                    <td>
                      <InputNumber
                        className="TIN"
                        min={0}
                        max={60}
                        placeholder="ສ່ວນຫຼຸດ %"
                        value={c_discount}
                        onChange={(e) => setc_discount(e)}
                      />
                    </td>
                    <td>
                      <Input
                        className="TIN"
                        readOnly
                        min={0}
                        placeholder="ຄ່າທຳນຽມຕົວຈິງ"
                        value={format(c_net_premuim)}
                      />
                    </td>
                  </tr>
                </tbody>
              </table> */}



              <div className="row row-cols-1 row-cols-md-4" style={{ padding: 5, backgroundColor: '#f2f2f2' }}>
                <div className="col" style={{ backgroundColor: '' }}>

                  {/* {o_type} */}
                  {/* ຄວາມຮັບຜິດຊອບທາງແຜ່ງຕໍ່ບຸກຄົນທີສາມ */}
                  {changLgValue(value, 35)}
                  <hr />
                  <Select
                    // placeholder="ປະເພດລົດ"
                    placeholder={changLgValue(value, 36)}
                    optionFilterProp="children"
                    onChange={onChange_Car}
                    className="TI"
                    style={{ width: "100%" }}
                  >
                    {listData.map((v, i) => {
                      return v.car_type_ml === 1 ? (
                        <Option key={i} value={JSON.stringify(v)}>
                          {value == 1 ? v.car_type_name_la : v.car_type_name_ch}
                        </Option>
                      ) : null;
                    })}
                  </Select>
                  <hr />
                  <Form.Item
                    // label=" ເລືອກປະເພດລົດ::"
                    name="o_optinname"
                    rules={[
                      {
                        required: true,
                        message: "ກະລຸນາເລືອກ  Option",
                      },
                    ]}
                    className="mb-0"
                  >
                    <Radio.Group
                      onChange={optionClick}
                      // value={a_option}
                      className="R"
                    >
                      {car_options_show.map((e, k) => {
                        return (
                          <Radio key={k} value={e}>
                            {e.car_op_name}
                          </Radio>
                        );
                      })}
                    </Radio.Group>
                  </Form.Item>
                </div>

                <div className="col" style={{ backgroundColor: '' }}>
                  {/* ຄ່ານຳນຽມຕົ້ນ */}
                  {changLgValue(value, 37)}
                  <hr />
                  <Input
                    className="TIN"
                    value={a_premuim}
                    // placeholder="ຄ່າທຳນຽມຕົ້ນ"
                    placeholder={changLgValue(value, 37)}
                  />
                </div>
                <div className="col" style={{ backgroundColor: '' }}>
                  {/* ສ່ວນຫຼຸດ */}
                  {changLgValue(value, 38)}
                  <hr />
                  <InputNumber
                    className="TIN"
                    min={0}
                    //   max={maxdis}
                    max={maxdis}
                    value={a_discount}
                    // placeholder="ສ່ວນຫຼຸດ"
                    placeholder={changLgValue(value, 38)}
                    onChange={(e) => seta_discount(e)}
                  />
                </div>
                <div className="col" style={{ backgroundColor: '' }}>
                  {/* ຄ່າທຳນຽມຕົວຈິງ */}
                  {changLgValue(value, 39)}
                  <hr />
                  <Input
                    className="TIN"
                    readOnly
                    value={format(a_net_premuim)}
                    // placeholder="ຄ່າທຳນຽມຕົວຈິງ"
                    placeholder={changLgValue(value, 39)}
                  />
                </div>
              </div>


              <hr />


              <div className="row row-cols-1 row-cols-md-4" style={{ padding: 5, backgroundColor: '' }}>
                <div className="col" style={{ backgroundColor: '' }}>
                  {/* ປົກປ້ອງສິດແລະຮຽກສິນທົດແທນ */}
                  {changLgValue(value, 40)}
                </div>

                <div className="col" style={{ backgroundColor: '' }}>

                </div>
                <div className="col" style={{ backgroundColor: '' }}>

                </div>
                <div className="col" style={{ backgroundColor: '' }}>
                  <InputNumber
                    className="TIN"
                    readOnly
                    min={0}
                    placeholder={changLgValue(value, 40)}
                    value={h}
                  />
                </div>
              </div>


              <hr />



              <div className="row row-cols-1 row-cols-md-4" style={{ padding: 5, backgroundColor: '#f2f2f2' }}>
                <div className="col" style={{ backgroundColor: '' }}>
                  {/* ປະເພດຜູ້ຂັບຂີ່ */}
                  {changLgValue(value, 41)}
                  <hr />


                  <Form.Item
                    name="driveType"
                    rules={[{ required: true, message: "plece select type driver" }]}
                  >

                    <Radio.Group
                      onChange={(v) => {
                        // console.log("ປະເພດຜູ້ຂັບຂີ່");
                        setdriveTypeOne(v.target.value);
                        console.log("reset optionType")
                        form.resetFields(["optionType"]);
                        setdriveAmount(0)
                        seti(0)
                      }}
                      className="R"
                    >
                      {driveType.map((e, k) => {
                        return (
                          <Radio key={k} value={e}>
                            {e.driver_name}
                          </Radio>
                        );
                      })}
                    </Radio.Group>
                  </Form.Item>


                </div>

                <div className="col" style={{ backgroundColor: '' }}>
                  {/* ທາງເລືອກຜູ້ຂັບຂີ່ */}
                  {changLgValue(value, 46)}

                  <hr />

                  <Form.Item
                    name="optionType"
                    rules={[{ required: true, message: "plece select option driver" }]}
                  >
                    <Select
                      // placeholder="ທາງເລືອກຜູ້ຂັບຂີ່"
                      placeholder={changLgValue(value, 46)}
                      value={selectedValue_driver_op}
                      onChange={(v) => {
                        //   console.log(v);
                        setSelectedValue_driver_op(
                          JSON.parse(v).driver_op_code
                        );
                        setOpDriveTypeOne(JSON.parse(v));
                      }}
                      className="TI"
                      style={{ width: "100%" }}
                    >
                      {opDriveType?.map((v) => {
                        // console.log(v.driver_op_id);
                        // console.log(v.driver_op_code);
                        if (
                          v?.driver_op_id == 1 ||
                          v?.driver_op_id == 2 ||
                          v?.driver_op_id == 3 ||
                          v?.driver_op_id == 4
                        ) {
                          return;
                        }

                        if (opCarType.car_op_name == "A4") {
                          //ຖ້າວ່າທາງເລືອກການຂາຍແມ່ນ A4 ໃຫ້ສາມາດເລືອກ I6 ໄດ້
                          return (
                            <Option
                              key={v.driver_op_id}
                              value={JSON.stringify(v)}
                            >
                              {v.driver_op_code}
                            </Option>
                          );
                        } else {
                          if (v.driver_op_id != 8) {
                            return (
                              <Option
                                key={v.driver_op_id}
                                value={JSON.stringify(v)}
                              >
                                {v.driver_op_code}
                              </Option>
                            );
                          }
                        }
                      })}
                    </Select>
                  </Form.Item>
                </div>
                <div className="col" style={{ backgroundColor: '' }}>
                  {/* ຈຳນວນຜູ້ຂັບຂີ່ */}
                  {changLgValue(value, 48)}
                  <hr />
                  <InputNumber
                    className="TIN"
                    min={0}
                    max={50}
                    value={driveAmount}
                    onChange={(e) => setdriveAmount(e)}
                  />
                </div>
                <div className="col" style={{ backgroundColor: '' }}>
                  {/* ຄ່າທຳນຽມຜູ້ຂັບຂີ່ */}
                  {changLgValue(value, 49)}
                  <hr />
                  <Input
                    className="TIN"
                    readOnly
                    min={0}
                    placeholder="ຜູ້ຂັບຂີ່"
                    value={format(i)}
                  />


                </div>
              </div>


              <hr />


              <div className="row row-cols-1 row-cols-md-4" style={{ padding: 5, backgroundColor: '' }}>
                <div className="col" style={{ backgroundColor: '' }}>
                  {/* ຄວາມເສຍຫາຍຕໍ່ກັບໂຕລົດ */}
                  {changLgValue(value, 45)}
                </div>

                <div className="col" style={{ backgroundColor: '' }}>
                  {/* ຄ່ານຳນຽມຕົ້ນ */}
                  {changLgValue(value, 37)}
                  <hr />
                  <Input
                    className="TIN"
                    readOnly
                    min={0}
                    placeholder="ຄ່າທຳນຽມຕົ້ນ"
                    value={format(c_premuim)}
                  />
                </div>
                <div className="col" style={{ backgroundColor: '' }}>
                  {/* ສ່ວນຫຼຸດ */}
                  {changLgValue(value, 38)}
                  <hr />
                  <InputNumber
                    className="TIN"
                    min={0}
                    max={60}
                    placeholder="ສ່ວນຫຼຸດ %"
                    value={c_discount}
                    onChange={(e) => setc_discount(e)}
                  />
                </div>
                <div className="col" style={{ backgroundColor: '' }}>
                  {/* ຄ່າທຳນຽມຕົວຈິງ */}
                  {changLgValue(value, 39)}
                  <hr />
                  <Input
                    className="TIN"
                    readOnly
                    min={0}
                    placeholder="ຄ່າທຳນຽມຕົວຈິງ"
                    value={format(c_net_premuim)}
                  />
                </div>
              </div>












            </Card>
            <Card className="C">
              <Divider orientation="left" plain>
                {/* ຄິດໄລຄ່າທຳນຽມ */}
                {changLgValue(value, 49)}
              </Divider>
              <div className="B">
                <div className="B1">
                  {/* ຄ່າທຳນຽມຕົວຈິງບໍ່ທັນລວມອາກອນ  */}
                  {changLgValue(value, 50)}
                </div>
                <div className="B2">{format(premuim)}</div>
              </div>
              <div className="B">
                <div className="B1">
                  {" "}
                  {/* ອາກອນມູນຄ່າເພີ່ມ */}
                  {changLgValue(value, 51)}
                  {format(getTax * 100)} %{" "}
                </div>
                <div className="B2">{format(vat)}</div>
              </div>
              <div className="B">
                <div className="B1">
                  {/* ຄ່າຂື້ນທະບຽນ  */}
                  {changLgValue(value, 52)}
                </div>
                <div className="B2">{format(register)}</div>
              </div>
              <div className="B">
                <div className="B1">
                  {/* ລວມມູນຄ່າຕ້ອງຈ່າຍ */}
                  {changLgValue(value, 53)}
                </div>
                <div className="B2">{format(total_premuim)}</div>
              </div>
            </Card>
            <Card className="C">
              <Divider orientation="left" plain>
                {/* ການຊຳລະເງິນ */}
                {changLgValue(value, 54)}
              </Divider>
              <div className="BDP">
                <div className="B1DP">
                  {/* ສະຖານະການຊຳລະ */}
                  {changLgValue(value, 55)}
                </div>
                <div className="B2DP">
                  <Radio.Group
                    onChange={(e) => {
                      setemp_paid(e.target.value);
                    }}
                    value={emp_paid}
                  >
                    <Radio value={0}>
                      {/* ລໍຖ້າການຊຳລະ */}
                      {changLgValue(value, 56)}
                    </Radio>
                    <Radio value={1}>
                      {/* ຊຳລະສົມບູນ */}
                      {changLgValue(value, 57)}
                    </Radio>
                  </Radio.Group>
                </div>
              </div>
            </Card>
            <br />
            {/* *ເພີ່ມວັນສິ້ນສຸດດ້ວຍຕົນເອງ{" "}
            <span style={{ color: "red" }}>
              {" "}
              (ຖ້າປິດສັນຍາຈະຄຸ້ມກັນເປັນເວລາ 1 ປີ){" "}
            </span>
            <Switch
              checked={addEnd}
              checkedChildren="ປິດ"
              unCheckedChildren="ເປີດ"
              onChange={(e) => {
                setAddEnd(e);
                form.setFieldsValue({ start: "" });
                form.setFieldsValue({ end: "" });
              }}
            /> */}
            <div className="BDP mt-2">
              <div className="B1DP">
                <Form.Item
                  label={changLgValue(value, 58)}
                  name="start"
                  rules={[
                    {
                      required: true,
                      message: "ກະລຸນາເລືອກ ວັນທີເລີ່ມຄຸ້ມກັນ ເສຍກ່ອນ",
                    },
                  ]}
                >
                  <DatePicker
                    // placeholder="ວັນທີເລີ່ມຄຸ້ມກັນ"
                    placeholder={changLgValue(value, 59)}
                    className="DP"
                    //showTime
                    onChange={onChange_timestart}
                    format={dateFormat}
                    disabledDate={(current) =>
                      current.isBefore(moment().subtract(1, "day"))
                    }
                  />
                </Form.Item>
              </div>

              {addEnd && (
                <div className="B2DP">
                  <Form.Item
                    label=" ວັນທີສຶ້ນສຸດຄຸ້ມກັນ::"
                    name="end"
                    rules={[
                      {
                        required: true,
                        message: "ກະລຸນາເລືອກ  ວັນທີສຶ້ນສຸດຄຸ້ມກັນ ເສຍກ່ອນ",
                      },
                    ]}
                  >
                    <DatePicker
                      placeholder="ວັນທີສຶ້ນສຸດຄຸ້ມກັນ"
                      className="DP"
                      showTime
                      onChange={onChange_timeend}
                      format={dateFormat}
                    />
                  </Form.Item>
                </div>
              )}
            </div>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                style={{ width: "100%" }}
              >
                {/* ບັນທຶກຂໍ້ມູນ */}
                {changLgValue(value, 60)}
              </Button>
            </Form.Item>
          </div>
        </Form>
      )}
      <br />
      {/* "ກວດຂໍ້ມູນໃຫ້ລະອຽດກ່ອນການບັນທືກ"  */}
      <Modal
        title={changLgValue(value, 61)}
        visible={modalsave}
        onOk={() => {
          if (stateButtonSave) {
            createPolicy();
          } else {
            alert(
              // "ກະລຸນາລໍ ຖ້າທ່ານໃດ້ກົດບັນທຶກຂໍ້ມູນແລ້ວ"
              changLgValue(value, 84)
            );
          }
        }}
        onCancel={() => setmodalsave(false)}
        okText={changLgValue(value, 63)}
        cancelText={changLgValue(value, 62)}
      >
        <div className="B">
          <div className="B1">
            {/* ຜູ້ໃດ້ຮັບການປະກັນໄພ  */}
            {changLgValue(value, 7)}
          </div>
          <div className="B2">{o_name}</div>
        </div>
        <div className="B">
          <div className="B1">
            {/* ເລກທະບຽນ */}
            {changLgValue(value, 13)}
          </div>
          <div className="B2">{o_plate}</div>
        </div>
        <div className="B">
          <div className="B1">
            {/* ເລກຈັກ */}
            {changLgValue(value, 16)}
          </div>
          <div className="B2">{o_engine}</div>
        </div>
        <div className="B">
          <div className="B1">
            {/* ເລກຖັງ  */}
            {changLgValue(value, 17)}
          </div>
          <div className="B2">{o_chassis}</div>
        </div>
        <div className="B">
          <div className="B1">
            {/* ການຄຸ້ມກັນ  */}
            {changLgValue(value, 86)}
          </div>
          <div className="B2">{cover}</div>
        </div>
        <div className="B">
          <div className="B1">
            {/* ວັນທີເລີ່ມຄຸ້ມກັນ  */}
            {changLgValue(value, 76)}
          </div>
          <div className="B2">{startCover}</div>
        </div>
        <div className="B">
          <div className="B1">
            {/* ວັນທີສຶ້ນສຸດຄຸ້ມກັນ  */}
            {changLgValue(value, 77)}
          </div>
          <div className="B2">{endCover}</div>
        </div>
        <div className="B">
          <div className="B1">
            {/* ລວມມູນຄ່າຕ້ອງຈ່າຍ  */}
            {changLgValue(value, 85)}
          </div>
          <div className="B2">{format(total_premuim)}</div>
        </div>
        <div className="B">
          <div className="B1">
            {/* ສະຖານະການຊຳລະ */}
            {changLgValue(value, 57)}
          </div>
          <div className="B2">
            {" "}
            {emp_paid === 1 ?
              //  "ຊຳລະສົມບູນ"
              changLgValue(value, 57)
              :
              // "ລໍຖ້າການຊຳລະ"
              changLgValue(value, 56)
            }
          </div>
        </div>
      </Modal>
    </>
  );
}

export default SellThirt_2;

export function fromTypeCar(a_type_power, set_a_type_power, value) {
  return (
    <div
      style={{
        height: 33,
        display: "flex",
        alignItems: "center",
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: "#D7D7D7",
        padding: "0 10px",
      }}
    >
      <label style={{ marginRight: 20, marginBottom: 0 }}>
        {/* ປະເພດລົດທີ່ອອກສັນຍາ:{" "} */}
        {changLgValue(value, 20)}
      </label>
      <Radio.Group
        onChange={(itemValue) => {
          set_a_type_power(itemValue.target.value);
        }}
        value={a_type_power}
      //  className="R"
      >
        <Radio value={0}>
          {changLgValue(value, 21)}
        </Radio>
        <Radio value={1}>
          {/* ໄຟຟ້າ */}
          {changLgValue(value, 22)}
        </Radio>
      </Radio.Group>
    </div>
  );
}





export function FromFineOldPolicy({ agent_Code, token, retoken, set_oldPolicy, value }) {
  const [form] = Form.useForm();
  const [policy, set_policy] = useState([])
  const [loadding, set_loadding] = useState(false)
  const handleSubmit = (values) => {
    // console.log('Input Value:', values.inputValue);
    // console.log('radioOption Value:', values.radioOption);
    // console.log('agent_Code Value:', agent_Code);


    let dataSetForGet = {
      agentCode: agent_Code,
      // agentCode: 1006,
      no: values.inputValue,
      type: values.radioOption
    }
    // console.table(dataSetForGet)
    getData(dataSetForGet, token, retoken)

    //  form.resetFields();
  };

  async function getData(dataSetForGet, token, retoken) {
    try {
      set_loadding(true)
      let l = ip + "sell_2_online/ReportPolicyForRenewPolicy";
      let data = await getDataPost_2(
        l,
        dataSetForGet,
        token,
        retoken
      );

      set_policy(showPolicyEnd(data))



    } catch (error) {
      set_policy([])
    }

    finally {
      set_loadding(false)
    }
  }


  return (
    <div >
      {/* <h3>ข้อมูลสำหรับ {agent_Code}</h3> */}
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          label={` ${changLgValue(value, 95)}`} //ປະເພດສັນຍາ
          name="radioOption"
          rules={[{ required: true, message: 'ກະລຸນາໃສ່ຂໍ້ມູນໃຫ້ຄົບຖ້ວນ!' }]}
        >
          <Radio.Group>
            <Radio value="paper">
              {/* ສັນຍາ ແບບຂຽນ  */}
              {changLgValue(value, 96)}
            </Radio>
            <Radio value="online">
              {/* ສັນຍາ ແບບ ອີເລັກໂຕນິກ */}
              {changLgValue(value, 97)}
            </Radio>

          </Radio.Group>
        </Form.Item>
        <Form.Item
          // "ເລກທີສັນຍາ"
          label={`${changLgValue(value, 98)}`}
          name="inputValue"

          rules={[{ required: true, message: 'ກະລຸນາໃສ່ຂໍ້ມູນໃຫ້ຄົບຖ້ວນ!' }]}
        >
          <InputNumber style={{ width: "100%" }} placeholder="ປ້ອນເລກທີສັນຍາ..." />
        </Form.Item>
        <Button loading={loadding} type="primary" htmlType="submit" >
          {/* ຄົ້ນຫາຂໍ້ມູນ */}
          {changLgValue(value, 99)}
        </Button>
      </Form>
      <hr />
      {/* {JSON.stringify(policy)} */}




      <List
        grid={{ gutter: 16, column: 1 }}
        dataSource={policy}
        renderItem={(item) => (
          <List.Item>
            <Card title={`Policy No: ${item.policy_concat_no}`}>
              <p><strong>
                {/* ປະເພດສັນຍາ */}
                {changLgValue(value, 95)}
                :</strong> {item.type}</p>
              <p><strong>
                {/* ຕົວແທນ */}
                {changLgValue(value, 102)}
                :</strong> {item.USER}</p>
              <p><strong>
                {/* ຊື່ລູກຄ້າ */}
                {changLgValue(value, 7)}
                :</strong> {item.o_name}</p>
              <p><strong>
                {/* ທີ່ຢູ່ */}
                {changLgValue(value, 105)}
                :</strong> {item.o_address}</p>
              <p><strong>
                {/* ເບີໂທ */}
                {changLgValue(value, 11)}
                :</strong> {item.o_tel}</p>
              <p><strong>
                {/* ປະເພດລົດ */}
                {changLgValue(value, 20)}
                :</strong> {item.o_type}</p>
              <p><strong>
                {/* ຫຍີ່ຫໍ້ລົດ */}
                {changLgValue(value, 12)}
                :</strong> {item.o_make}</p>
              <p><strong>
                {/* ປ້າຍລົດ */}
                {changLgValue(value, 13)}
                :</strong> {item.o_plate}</p>
              <p><strong>
                {/* ສີລົດ */}
                {changLgValue(value, 14)}
                :</strong> {item.o_color}</p>
              <p><strong>
                {/* ຄວາມແຮງ */}
                {changLgValue(value, 15)}
                :</strong> {item.o_power}</p>
              <p><strong>
                {/* ເລກຈັກ */}
                {changLgValue(value, 16)}
                :</strong> {item.o_engine}</p>
              <p><strong>
                {/* ເລກຖັງ */}
                {changLgValue(value, 17)}
                :</strong> {item.o_chassis}</p>
              <p><strong>
                {/* ນຳໜັກ */}
                {changLgValue(value, 18)}
                :</strong> {item.o_weight}</p>
              <p><strong>
                {/* ຈຳນວນບ່ອນນັ່ງ */}
                {changLgValue(value, 19)}
                :</strong> {item.o_seats}</p>
              <p><strong>
                {/* ຄ່າທຳນຽມຕົ້ນປະຈຸບັນ */}
                {changLgValue(value, 50)}
                :</strong> {item.premuim.toLocaleString()}</p>
              <p><strong>
                {/* ອາກອນມູນຄ່າເພີ່ມ */}
                {changLgValue(value, 51)}
                :</strong> {item.vat.toLocaleString()}</p>
              <p><strong>
                {/* ຄ່າລົງທະບຽນປະຈຸບັນ */}
                {changLgValue(value, 52)}
                :</strong> {item.register.toLocaleString()}</p>
              <p><strong>
                {/* ຄ່າທຳນຽມທັງໝົ້ດປະຈຸບັນ */}
                {changLgValue(value, 53)}
                :</strong> {item.total_premuim.toLocaleString()}</p>
              <p><strong>
                {/* ວັນທີເລີ່ມຄຸ້ມກັນ */}
                {changLgValue(value, 58)}
                :</strong> {moment(item.start).format("DD-MM-YYYY")}</p>
              <p><strong>
                {/* ວັນທີສິ້ນສຸດການຄຸ້ມກັນ */}
                {changLgValue(value, 59)}
                :</strong> {moment(item.end).format("DD-MM-YYYY")}</p>
              <p><strong>
                {/* ການຄຸ້ມກັນ */}
                {changLgValue(value, 86)}
                :</strong> {item.cover}</p>
              <p><strong>
                {/* ການເກີດອຸປະຕິເຫດ */}
                {changLgValue(value, 103)}
                :</strong> <span style={{ color: 'red' }}>{processClaims(item.claim || [])}</span></p>
            </Card>
          </List.Item>
        )}
      />
      {policy.length > 0 && <Button type="primary" onClick={() => {
        // console.log(policy)
        set_oldPolicy(policy)
      }}>
        {/* ຕໍ່ສັນຍານີ້ */}
        {changLgValue(value, 104)}
      </Button>}
      <br />
    </div>
  );
}